
export class Notifications {

    id?: number;
    tipo_actividad?: string;
    descripcion?: string;
    fecha_creacion?: string;
    colorClass: string;
    icon: string;
    leida: boolean;

   


    constructor(notification?: any) {
        this.id = notification?.id ?? 0;
        this.tipo_actividad = notification?.tipo_actividad ?? '';
        this.descripcion = notification?.descripcion ?? '';
        this.fecha_creacion = notification?.fecha_creacion ?? ''; 
        this.colorClass = notification?.colorClass ?? '';
        this.icon = notification?.icon ?? '';
        this.leida = notification?.leida === 1 ? true : false;
      }
}
